import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const BooksIcon: FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_706_3074)"><path d="M8.25 3.75H5.25V20.25H8.25V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M8.25 3.75H5.25V6.75H8.25V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M11.25 3.75H8.25V20.25H11.25V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M11.25 17.25H8.25V20.25H11.25V17.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M14.5483 3.7077L11.7034 4.6596L16.9389 20.307L19.7838 19.3551L14.5483 3.7077Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M18.8367 16.5074L15.9917 17.4593L16.9436 20.3042L19.7886 19.3523L18.8367 16.5074Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M14.5439 3.6955L11.699 4.6474L12.6509 7.4924L15.4959 6.5405L14.5439 3.6955Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<defs><clipPath id="clip0_706_3074"><rect width="24" height="24" fill="white" /></clipPath></defs></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default BooksIcon;